import { graphql } from 'src/graphql';

export const BookingSegmentsFields = graphql(`
  fragment BookingSegmentsFields on BookingSegment @_unmask {
    _id
    name
    target_percent
    enabled
    conditions {
      _id
      field
      operator
      value_type
      values
      screenerQuestionId
    }
  }
`);
